var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketsAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77778 3H15.0349L20 7.82409V20.2727C20 21.2267 19.2041 22 18.2222 22H5.77778C4.79594 22 4 21.2267 4 20.2727V4.72727C4 3.77333 4.79594 3 5.77778 3ZM12.8906 4.72727H5.77734V20.2727H18.2218V9.90909H14.6684C13.6866 9.90909 12.8906 9.13576 12.8906 8.18182V4.72727ZM14.6684 5.08711V8.18182H17.8536L14.6684 5.08711ZM8.44531 16.8182V15.0909H13.7786V16.8182H8.44531ZM8.44531 11.6364V13.3636H15.5564V11.6364H8.44531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsAsset);
export default __webpack_public_path__ + "static/media/ticketsAsset.852330e58dba6ac98a7dae6b0a58ad69.svg";
export { ForwardRef as ReactComponent };